import { useState } from 'react';
import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/homeData';

const faqs = [
  {
    q: '比基尼护士的写真拍摄需要提前多久预约？',
    a: '建议提前1-2周预约，特别是周末和节假日档期较为紧张。您可以通过联系表单或微信进行预约，我们会在24小时内与您确认拍摄时间。',
  },
  {
    q: '拍摄写真需要自己准备服装吗？',
    a: '不需要！比基尼护士提供全套拍摄服装和道具，包括多种款式的护士服、白大褂、听诊器、注射器模型等。如果您有特别喜欢的服装或配饰，也可以自带。',
  },
  {
    q: '角色扮演服装支持定制吗？',
    a: '支持！我们提供从XS到XXXL的全尺码选择，也接受个性化定制需求。定制周期通常为7-14个工作日，具体请咨询客服。',
  },
  {
    q: '美体护理使用的产品安全吗？',
    a: '我们所有产品均通过国家相关安全检测，采用医美级或医用级标准。护理师会根据您的肤质进行皮肤测试后再进行护理，确保安全无刺激。',
  },
  {
    q: '写真拍摄后多久可以拿到成片？',
    a: '拍摄完成后7个工作日内，我们会提供精修成片。如需加急处理，可选择加急服务，3个工作日内交付。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    setFormStatus('submitting');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt' && value) {
          body.append(key, String(value));
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9q4u0ue3oq4jqumtgeg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormError(serverMsg || '提交失败，请稍后再试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    }
  };

  return (
    <main className="pt-16">
      <section className="py-12 md:py-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            关于比基尼护士
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl leading-relaxed">
            融合医护专业与时尚美学的创意品牌
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="lg:w-1/2">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20brand%20photography%20studio%20interior%2C%20warm%20cream%20and%20rose%20tones%2C%20fashion%20editorial%20workspace%2C%20soft%20natural%20light%2C%20minimalist%20luxury%20aesthetic%2C%20professional%20creative%20environment&width=700&height=500&seq=about-brand-001&orientation=landscape"
                alt="比基尼护士品牌形象"
                className="w-full rounded-lg object-cover object-top h-72 md:h-96"
              />
            </div>
            <div className="lg:w-1/2">
              <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
                Brand Story
              </p>
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-5">
                品牌故事
              </h2>
              <div className="text-foreground-700 text-sm md:text-base leading-relaxed space-y-4">
                <p>
                  比基尼护士诞生于一个大胆的创意——谁说医护只能是严肃的？谁说性感不能是专业的？我们相信，每一位女性都拥有多重魅力，而我们的使命，就是用镜头和设计，帮你发现那个不一样的自己。
                </p>
                <p>
                  我们的团队由资深摄影师、服装设计师和专业护理师组成。我们以医护行业的严谨标准要求自己，以时尚行业的审美眼光打磨作品。无论是写真拍摄、服装定制还是美体护理，我们都力求做到极致。
                </p>
                <p>
                  成立8年来，我们已服务超过5000位客户，积累了300多套主题造型方案。每一位比基尼护士的客户，都是我们品牌故事中不可或缺的一章。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
              Reputation
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              客户口碑
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              98%好评率，5000+满意客户的选择
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-7"
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                  &ldquo;{t.content}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
              FAQ
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              常见问题
            </h2>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 text-lg ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openFaq === index && (
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-10">
              <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
                Contact
              </p>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                有任何问题或想预约服务？请填写下方表单，我们会尽快回复
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />

              {formStatus === 'success' && (
                <div className="mb-6 p-4 bg-secondary-50 text-secondary-800 rounded-md text-sm border border-secondary-200">
                  <i className="ri-check-line mr-2"></i>
                  感谢您的留言！我们会尽快与您联系。
                </div>
              )}

              {formStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 text-red-700 rounded-md text-sm border border-red-200">
                  <i className="ri-error-warning-line mr-2"></i>
                  {formError}
                </div>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    电话 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="contact-phone"
                    name="phone"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入您的电话"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  邮箱
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="contact-interest" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  感兴趣的服务 <span className="text-primary-500">*</span>
                </label>
                <select
                  id="contact-interest"
                  name="interest"
                  required
                  className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                >
                  <option value="">请选择您感兴趣的服务</option>
                  <option value="写真拍摄">护士主题写真</option>
                  <option value="角色扮演服装">角色扮演服装</option>
                  <option value="美体护理">美体护理</option>
                  <option value="其他">其他咨询</option>
                </select>
              </div>

              <div className="mb-5">
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言内容（最多500字）"
                />
              </div>

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full py-3 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {formStatus === 'submitting' ? '提交中...' : '提交留言'}
              </button>
            </form>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </main>
  );
}